import React from 'react';

/**
 * Renders installation command code with syntax highlighting
 */
export const renderInstallationCode = (language) => {
    if (language === 'python') {
        return (
            <code style={{ display: 'block' }}>
                <span style={{ color: "#4FC1FF" }}>pip</span> <span style={{ color: "#CE9178" }}>install</span> <span style={{ color: "#9CDCFE" }}>specific_ai</span>
            </code>
        );
    } else if (language === 'go') {
        return (
            <code style={{ display: 'block' }}>
                <span style={{ color: "#4FC1FF" }}>go</span> <span style={{ color: "#CE9178" }}>get</span> <span style={{ color: "#9CDCFE" }}>github.com/marketplace-specificai/go-specific-ai-sdk@latest</span>
            </code>
        );
    } else {
        return (
            <code style={{ display: 'block' }}>
                <span style={{ color: "#FFA07A" }}>npm</span> <span style={{ color: "#CE9178" }}>install</span> <span style={{ color: "#569CD6" }}>specific-ai</span>
            </code>
        );
    }
};
